<p-panel
  styleClass="panel-shadow"
  *ngIf="
    (organisationTypeId == 1 || organisationTypeId == 2) &&
    inspectionHandover &&
    inspectionHandover.showInspectionHandover
  "
  [style]="{ 'margin-top': '1em' }"
>
  <p-header>
    <div class="panel-header">Inspection Handover</div>
  </p-header>

  <div class="grid-label-value pt-2">
    <div>Name:</div>
    <div class="value">{{ inspectionHandover.fullName }}</div>
  </div>

  <div
    class="grid-label-value pt-2"
    style="padding-top: 10px; margin-top: 10px; border-top: 1px solid #dfdfdf"
  >
    <div>Email:</div>
    <div class="value" style="word-wrap: break-word">
      {{ inspectionHandover.email }}
    </div>
  </div>

  <div
    class="grid-label-value pt-2"
    style="padding-top: 10px; margin-top: 10px; border-top: 1px solid #dfdfdf"
  >
    <div class="last-line">Contact:</div>
    <div class="last-line value" style="word-wrap: break-word">
      {{ inspectionHandover.contactNumber }}
    </div>
  </div>

  <div
    class="grid-label-value pt-2"
    style="padding-top: 10px; margin-top: 10px; border-top: 1px solid #dfdfdf"
  >
    <div class="last-line">Signature:</div>
    <a
      *ngIf="inspectionHandover.signatureLocation"
      href="{{ inspectionHandover.signatureLocation }}"
      target="_blank"
      class="last-line value"
      style="word-wrap: break-word"
    >
      <i class="fa fa-image fa-2x cursor-pointer"> </i>
    </a>
  </div>

  <div
    [class.ghost]="loading"
    style="padding-top: 10px; margin-top: 10px; border-top: 1px solid #dfdfdf"
  >
    <div class="flex align-items-center justify-content-between">
      <div class="grid-label-value">
        <div>Recordings:</div>
      </div>
      <div
        class="flex-shrink-1 link-style cursor-pointer"
        (click)="showAddInspectionRecording()"
        *ngIf="organisationTypeId == 1"
      >
        + add
      </div>
    </div>
  </div>
  <div
    class="recording"
    *ngFor="let media of inspectionHandover.media"
    style="width: 100%; word-wrap: break-word"
  >
    <div class="description">
      {{ media.description }}
    </div>
    <div class="play-icon" (click)="viewMedia(media)">
      <i class="fa fa-play-circle" aria-hidden="true"></i>
    </div>
  </div>
</p-panel>

<p-dialog
  header="Add Inspection Recording"
  [(visible)]="isAddInspectionRecordingVisible"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div class="style2023 p-3">
    <div class="mb-3">
      <input
        type="file"
        accept="video/mp4,video/quicktime,video/x-msvideo"
        #fileInput
        class="inspection-recording-file-input"
      />
    </div>

    <div class="input-group mt-3">
      <div class="input-group-item pt-2">
        <textarea
          pInputTextarea
          placeHolder="Description"
          class="no-border"
          [(ngModel)]="videoDescription"
          [maxlength]="250"
          style="width: 100%; height: 50px"
        ></textarea>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="text-right">
      <button
        type="button"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
        (click)="close()"
      ></button>
      <button
        type="button"
        pButton
        label="Upload"
        class="ui-button ui-button-primary"
        [disabled]="videoDescription?.trim().length == 0 || isUploading"
        (click)="handleInspectionRecordingUpload()"
      ></button>
    </div>
  </p-footer>

  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(128, 128, 128, 0.3);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
    *ngIf="isUploading"
  >
    <img src="assets/images/loader.gif" width="50" height="50" alt="load" style="opacity: 0.3" />
    <span style="color: #000000; font-weight: bold; margin-top: 10px"
      >Upload Progress: {{ uploadProgress }}%</span
    >
  </div>
</p-dialog>

<p-dialog
  header="View Inspection Handover Recording"
  [(visible)]="isViewInspectionRecordingVisible"
  [modal]="true"
  [style]="{ width: '1000px' }"
>
  <ng-container *ngIf="selectedMedia">
    <video
      [src]="selectedMedia.mediaURL"
      controls
      class="inspection-handover-video-player"
      controlsList="nodownload"
      preload="metadata"
    >
      Your browser does not support HTML5 video.
    </video>
  </ng-container>
</p-dialog>
